var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconIndexScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.008,
    height: 18.008,
    viewBox: "0 0 18.008 18.008",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.756 8.253v3.752a3.752 3.752 0 0 1-3.751 3.751H6.002a3.752 3.752 0 0 1-3.751-3.751v-.75M9.754 2.25H6.002a3.752 3.752 0 0 0-3.751 3.752v.75",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.506 9.004h-2.801l-1.3 3-2.603-6.002-1.4 3.002H2.251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.268 2.652c.234-.26.569-.407.919-.401a1.354 1.354 0 0 1 1.32 1.35c0 1.36-1.796 2.401-2.24 2.401-.442 0-2.238-1.042-2.238-2.4a1.35 1.35 0 0 1 1.32-1.351c.35-.006.685.14.919.401z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18.007v18.007H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndexScore);
export default __webpack_public_path__ + "static/media/iconIndexScore.661201ec2b8d06da76cd36b4697c599a.svg";
export { ForwardRef as ReactComponent };